import React from 'react';

import { Box, Text } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Task detail panel placeholder: title line, action bar (mark complete /
 * priority / date-range / assignee chips), and a 2-line description block.
 * Mirrors the real header in task-detail-tabs.web.tsx (px='l' py='m' outer
 * inset, p='xxs' title wrapper, my='l' action bar with 32px-tall chips) so
 * nothing shifts once the real content swaps in.
 */
export const TaskPanelSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'task-panel-skeleton',
}) => (
  <Box testID={testID} px='l' py='m'>
    <Box p='xxs'>
      <Skeleton variant='text' width='45%' height={22} />
    </Box>
    <Box
      flexDirection='row'
      alignItems='center'
      my='l'
      style={{ gap: theme.spacing.xs }}>
      <Skeleton variant='rect' width={159} height={32} borderRadius='m' />
      <Skeleton variant='rect' width={32} height={32} borderRadius='m' />
      <Skeleton variant='rect' width={110} height={32} borderRadius='m' />
      <Skeleton variant='rect' width={90} height={32} borderRadius='m' />
    </Box>
    <Box backgroundColor='grey01' borderRadius='xs' p='m'>
      <Text
        variant='labelEmphasizedChatDetialTitle'
        color='textSecondary'
        mb='xs'>
        Description
      </Text>
      <Box marginBottom='xxxs'>
        <Skeleton variant='text' width='90%' />
      </Box>
      <Skeleton variant='text' width='60%' />
    </Box>
  </Box>
);
